import React, { useEffect, useState } from 'react'
import waveActivePic from '../Img/Profile-active.png'
import wavePic from '../Img/Profile.png'
import messagePic from '../Img/Message.png'
import messageActivePic from '../Img/Message-active.png'
import tapPic from '../Img/Top.png'
import tapActivePic from '../Img/Tap-active.png'
import shufflePic from '../Img/Shuffle.png'
import shuffleActivePic from '../Img/Shuffle-active.png'
import askPic from '../Img/Ask.png'
import askActivePic from '../Img/Ask-active.png'
import { Link } from 'react-router-dom'


function Footer({active}) {
    const [message, setMessage] = useState();
    const [wave, setWave] = useState();
    const [tap, setTap] = useState();
    const [shuffle, setShuffle] = useState();
    const [ask, setAsk] = useState();

    useEffect(() => {
        if (active === 'wave'){
            setMessage(messagePic)
            setWave(waveActivePic)
            setTap(tapPic)
            setShuffle(shufflePic)
            setAsk(askPic)

        } else if (active === 'message') {
            setWave(wavePic)
            setMessage(messageActivePic)
            setTap(tapPic)
            setShuffle(shufflePic)
            setAsk(askPic)
        } else if(active === 'Tap') {
            setWave(wavePic)
            setMessage(messagePic)
            setTap(tapActivePic)
            setShuffle(shufflePic)
            setAsk(askPic)
        } else if (active === 'shuffle'){
            setWave(wavePic)
            setMessage(messagePic)
            setShuffle(shuffleActivePic)
            setTap(tapPic)
            setAsk(askPic)
        } else {
          setAsk(askActivePic)
          setMessage(messagePic)
          setWave(wavePic)
          setShuffle(shufflePic)
          setTap(tapPic)
        }
        
    },[active]) 

  return (
    <div className='p-5 flex justify-evenly bg-white sticky bottom-0 left-0 right-0'>
        <Link to='/wave' className='space-y-1 cursor-pointer'>
          
          <img className='ml-1 w-5' src={wave} alt="" />
          <h1 className='text-[0.75rem]'>Wave</h1>
        </Link>
        <Link to='/message' className='space-y-1 flex flex-col justify-center cursor-pointer'>
          
          <img className='mx-auto w-5 flex justify-center' src={message} alt="" />
          <h1 className='text-[0.75rem] flex justify-center text-gray-500'>Message</h1>
        </Link>
        <Link to='/tap' className='space-y-1 flex flex-col justify-center cursor-pointer'>
          
          <img className='ml-2 w-5 flex justify-center' src={tap} alt="" />
          <h1 className='text-[0.75rem] flex justify-center text-gray-500'>Tap</h1>
        </Link>
        <Link to='/shuffle' className='space-y-1 flex flex-col justify-center cursor-pointer'>
          
          <img className='mx-auto w-5 flex justify-center' src={shuffle} alt="" />
          <h1 className='text-[0.75rem] flex justify-center text-gray-500'>Shuffle</h1>
        </Link>
        <Link to='/ask' className='space-y-1 flex flex-col justify-center cursor-pointer'>
          
          <img className='ml-1 w-5 flex justify-center' src={ask} alt="" />
          <h1 className='text-[0.75rem] flex justify-center text-gray-500'>Ask</h1>
        </Link>
      </div>
  )
}

export default Footer